export default __webpack_public_path__ + "static/media/app1.aee27910.svg";